var UPPERCASE_REGEX = /([A-Z])/g;
var MS_REGEX = /^ms-/;
var KEYFRAMES_REGEX = /^@keyframes/;

var id = function id() {
  return Math.random().toString(36).substring(7);
};

var stringify = function stringify(selector, arr) {
  return "".concat(selector, " { ").concat(arr.join(" "), " }");
};

var hyphenateStyleName = function hyphenateStyleName(name) {
  return name.replace(UPPERCASE_REGEX, '-$1').toLowerCase().replace(MS_REGEX, '-ms-');
};

var hash = function hash(str) {
  var hash = 0,
      i,
      chr;
  if (str.length === 0) return hash;

  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }

  return hash;
};

var isKeyframes = function isKeyframes(str) {
  return KEYFRAMES_REGEX.test(str);
};

export { id, stringify, hyphenateStyleName, hash, isKeyframes };